// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mb-48[data-v-11f27798]{margin-bottom:48px}", ""]);
// Exports
module.exports = exports;
